import { render, staticRenderFns } from "./jackpots-bar.vue?vue&type=template&id=264d9815"
import script from "./jackpots-bar.vue?vue&type=script&lang=js"
export * from "./jackpots-bar.vue?vue&type=script&lang=js"
import style0 from "./jackpots-bar.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/jackpots/jackpots-bar/jackpots-bar.vue
// module id = 1cP4
// module chunks = 0